<div class="modal">
    <div class="content-strip">
        <mat-card appearance="outlined" class="card" *ngIf="user">
            <mat-card-header class="card-header">
                <mat-card-title>Caballus User Found:</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div class="details">
                    <div class="detail">
                        <div class="label big-label">Username:</div>
                        <div class="value">{{ user?.url }}</div>
                    </div>
                    <div class="detail">
                        <div class="label big-label">First Name:</div>
                        <div class="value">{{ user?.firstName || '' }}</div>
                    </div>
                    <div class="detail">
                        <div class="label big-label">Last Name:</div>
                        <div class="value">{{ user?.lastName || '' }}</div>
                    </div>
                    <div class="detail">
                        <div class="label big-label">Email:</div>
                        <div class="value">{{ user?.email }}</div>
                    </div>
                </div>
                <div class="buttons">
                    <button mat-button class="large-round spinner center" (click)="goBack()">
                        No, Go Back
                    </button>
                    <button mat-button class="large-round spinner center" [disabled]="isAddFriendInProcess$ | async"
                            (click)="sendRequest()">
                        Add Friend
                        <mat-spinner *ngIf="isAddFriendInProcess$ | async"></mat-spinner>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
